import { combineReducers } from 'redux'
import sites from '../Sites/Store/reducers'
import projects from '../Projects/Store/reducers'
import contacts from '../Contacts/Store/reducers'
import materials from '../Materials/Store/reducers'
import hauls from '../Hauls/Store/reducers'
import ui from '../UI/Store/reducers'
import activeNow from '../ActiveNow/Store/reducers'
import dispatches from '../Dispatches/Store/reducers'
import UserState from './intialState'
import drivers from '../Drivers/Store/reducers'
import reports from '../Reports/Store/reducers'
import companies from '../Companies/Store/reducers'

const user = (state = UserState, action) => {
  switch (action.type) {
    case 'UPDATE_USER':
      return Object.assign({}, state, {
        userData: action.payload.user,
        loading: false
      })
    case 'LOGOUT_USER':
      return Object.assign({}, state, {
        userData: null,
        loggedIn: false,
        loading: false,
        hasLoggedOut: true
      })
    case 'LOGIN_USER':
      return Object.assign({}, state, {
        loggedIn: true
      })
    default:
      return state
  }
}

export default combineReducers({
  activeNow,
  contacts,
  hauls,
  materials,
  projects,
  sites,
  ui,
  user,
  dispatches,
  drivers,
  reports,
  companies
})
